import React from 'react'
import { useHistory } from 'react-router'
import { useAuth0 } from '@auth0/auth0-react'
import useStyles from './LoginStyles'
import LogoSVG from '../../assets/kaizoft-logo-orange-login.svg'
import HeroImg from '../../assets/login-hero.png'

const Login = () => {
  const classes = useStyles()
  const history = useHistory()

  const { loginWithRedirect, isAuthenticated } = useAuth0()

  if (isAuthenticated) history.push(`${window.location.origin}/home`)

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        {/* Left Side - Login Form */}
        <div className={classes.leftPanel}>
          <div className={classes.formContainer}>
            <div className={classes.logoSection}>
              <img src={LogoSVG} alt="Kaizoft" className={classes.logo} />
              <div className={classes.brandText}>
                <span>Kaizoft</span>
                <span>Clear To Build</span>
              </div>
            </div>

            <div style={{ marginLeft: 50 }}>
              <div style={{ textAlign: 'center' }}>
                <h2 className={classes.welcomeTitle}>
                  Welcome Back!
                </h2>
              </div>

              <div style={{ marginTop: '2rem' }}>
                <button
                  type="button"
                  onClick={() => loginWithRedirect()}
                  className={classes.submit}
                >
                  Sign In
                </button>

                <div className={classes.linkSection}>
                  <div className={classes.linkText}>
                    <span>Don't have an account? </span>
                    <button style={{ color: '#F37E57' }} onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}>
                      Click Here
                    </button>
                  </div>
                  <div className={classes.linkText}>
                    Back to Kaizoft&nbsp;
                    <a style={{ color: '#F37E57' }} href="https://kaizoft.com">
                      Homepage
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Hero Image */}
        <div className={classes.rightPanel}>
          <div className={classes.rightInner}>
            {/* Background Container - The "shifted back" layer */}
            <div className={classes.bgCard}>
              {/* Image container routed to create shift relative to the background below */}
              <div className={classes.heroImageContainer}>
                <img
                  className={classes.heroImage}
                  src={HeroImg}
                  alt="Office Workspace"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
